import { styled } from '@mui/material/styles';
import { Stack, Container, Typography } from '@mui/material';
import AuthLayout from '../layouts/AuthLayout';
import Page from '../components/Page';
import { AdminLoginForm } from '../components/authentication/login';
import { useLocation } from 'react-router-dom';
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex'
    }
}));

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function AdminLogin() {
    const location = useLocation();
    //console.log(location.state)
    if(location.state){
        sessionStorage.setItem('beforeLogin', location.state?.from?.pathname);
    }
    
    return (
        <RootStyle title="Admin Login">
            <Stack sx={{ mb: 7 }}> <AuthLayout /> </Stack>
            <Container maxWidth="sm">
                <ContentStyle>
                    <Stack sx={{ mb: 5 }}>
                        <Typography variant="h4" gutterBottom> Sign in to Extramarks Analytics</Typography>
                        <Typography sx={{ color: 'text.secondary' }}>Enter Admin Details Below.</Typography>
                    </Stack>
                    <AdminLoginForm />
                </ContentStyle>
            </Container>
        </RootStyle>
    );
}
